import { useSo5Competitions } from '@sorare/core/src/hooks/useSo5Competitions';

export const useForCompetitionsCollectionFilter = ({
  competitionEligibility,
  leagues,
}: {
  competitionEligibility?: string;
  leagues?: string[];
}) => {
  const { filterableSo5Competitions } = useSo5Competitions();

  const forCompetitions = (() => {
    const res = [];
    if (competitionEligibility) {
      const competition = filterableSo5Competitions.find(
        c => c.slug === competitionEligibility
      );
      if (competition) {
        res.push(...competition.competitions.map(c => c.slug));
      }
    }
    if (leagues) {
      res.push(...leagues.map(l => l.split('|')[1]));
    }
    return res;
  })().filter(Boolean);

  return { forCompetitions };
};
